export enum AllocationType {
  MainDistribution = 'main-distribution',
  ProductGroup = 'product-group',
  Product = 'product',
}
